export const sleep = (ms) => {
  return new Promise((res) => {
    setTimeout(() => {
      res()
    }, ms)
  })
}
